import React from 'react'
import { withTranslation } from 'react-i18next'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import store from './../../store'
import Editor from './Editor'
import ExpertComponentPanel from './ExpertComponentPanel.js'
import PopupSlides from './PopupSlides'
import PopupNav from './PopupNav'
import AssetManager from '../../common/components/AssetManager'
import AddNewSlide from '../AddNewSlide'
import MemoryOptions from '../Modal/MemoryOptions.js'
import RankBattleOptions from '../Modal/RankBattleOptions.js'
import BlockEditor from './BlockEditor/BlockEditor'

class EditorTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            assetmanager: {
                is_open: false,
                placeImageCallback: () => {},
            },
            addNewSlide: {
                is_open: false,
                options: [],
                selectCallback: () => {},
            },
            memory_modal: {
                is_open: false,
                setDataCallback: () => {},
            },
            rank_battle_modal: {
                is_open: false,
                setDataCallback: () => {},
                data: {},
            },
            remixAppData: null,
        }
    }

    async componentDidMount() {
        Editor.subscribeEditorTab(this.onEditorRequest.bind(this))

        if (Editor.getProjectConfig().isBlockEditor) {
            this.setState({
                remixAppData: await Editor.serializeProject(),
            })
        }
    }

    openPopup = popup => (state = {}) => {
        this.setState(prevState => ({
            ...prevState,
            [popup]: {
                ...prevState[popup],
                ...state,
                is_open: true,
            },
        }))
    }

    closePopup = popup => () => {
        this.setState(prevState => ({
            ...prevState,
            [popup]: {
                ...prevState[popup],
                is_open: false,
            },
        }))
    }

    onEditorRequest({ method, data, callback }) {
        const { project } = this.props

        switch (method) {
            case 'data_provider': {
                switch (project.projectType.customId.toLocaleUpperCase()) {
                    case 'MEMORY': {
                        this.openPopup('memory_modal')({ setDataCallback: callback })

                        break
                    }
                    case 'RANK_BATTLE': {
                        this.openPopup('rank_battle_modal')({ data, set_data: callback })

                        break
                    }
                    default:
                        break
                }

                break
            }
            case 'assetmanager_select_image': {
                this.openPopup('assetmanager')({ placeImageCallback: callback })
                break
            }
            case 'setup_share_properties': {
                // открыть окно выбора шаблона экрана и вернуть в callback данные по шарам... формат пока не ясен
                break
            }
            case 'add_new_slide': {
                this.openPopup('addNewSlide')({ options: data, selectCallback: callback })
                // data - array of {name, icon, json}, показать все элементы и вернуть только один который пользователь выберет
                // callback( data[selectedIndex] )
                break
            }
            case 'open_components_panel': {
                // открыть справа панель с выбором компонентов
                const el = document.getElementById('id-expert_components_panel')
                el.classList.add('active')
                ReactDOM.render(
                    <ExpertComponentPanel
                        addElement={callback}
                        data={data}
                        getEditedAppBoundingClientRect={Editor.getEditedAppBoundingClientRect}
                    />,
                    el,
                )
                break
            }
            case 'close_components_panel': {
                const el = document.getElementById('id-expert_components_panel')
                el.classList.remove('active')
                ReactDOM.render(null, el)
                break
            }
            case 'show_popup_slides': {
                const el = document.getElementById('id-popup_slides_cnt')
                ReactDOM.render(
                    <Provider store={store}>
                        <PopupSlides />
                    </Provider>,
                    el,
                )

                break
            }
            case 'hide_popup_slides': {
                const el = document.getElementById('id-popup_slides_cnt')
                ReactDOM.render(null, el)

                break
            }
            case 'show_popup_nav': {
                const el = document.getElementById('editor-popup-nav')
                if (el)
                    ReactDOM.render(
                        <Provider store={store}>
                            <PopupNav />
                        </Provider>,
                        el,
                    )

                break
            }
            case 'hide_popup_nav': {
                const el = document.getElementById('editor-popup-nav')
                if (el) ReactDOM.render(null, el)

                break
            }
            default:
                break
        }
    }

    componentWillUnmount() {
        // document.getElementById('editor_legacy_dom').style.display = 'none';
    }

    render() {
        const { project, events } = this.props
        const { assetmanager, addNewSlide, memory_modal, rank_battle_modal, remixAppData } = this.state

        return (
            <>
                {Editor.getProjectConfig().isBlockEditor && remixAppData && (
                    <BlockEditor
                        data={{
                            project,
                        }}
                        events={{
                            save: events.init_action('save--silent'),
                        }}
                        remixAppData={remixAppData}
                        onUpdate={data => Editor.getEditedApp().setData(data)}
                        editorRequest={this.onEditorRequest.bind(this)}
                    ></BlockEditor>
                )}

                <AssetManager
                    isOpen={assetmanager.is_open}
                    projectId={project.projectId}
                    onPlaceImage={assetmanager.placeImageCallback}
                    onClose={this.closePopup('assetmanager')}
                />

                <AddNewSlide
                    options={addNewSlide.options}
                    selectCallback={addNewSlide.selectCallback}
                    open={addNewSlide.is_open}
                    onClose={this.closePopup('addNewSlide')}
                />

                {memory_modal.is_open ? (
                    <MemoryOptions
                        is_open={true}
                        overlay_close={true}
                        project={project}
                        events={{
                            on_save: memory_modal.setDataCallback,
                            on_close: this.closePopup('memory_modal'),
                            on_open_asset_manager: () =>
                                console.log('[EditorTab]: handleClick__open_asset_manager_modal'),
                        }}
                    />
                ) : null}

                {rank_battle_modal.is_open ? (
                    <RankBattleOptions
                        overlay_close={true}
                        events={{ on_close: this.closePopup('rank_battle_modal') }}
                        is_open={rank_battle_modal.is_open}
                        data={rank_battle_modal.data}
                        set_data={rank_battle_modal.set_data}
                        project={project}
                    />
                ) : null}
            </>
        )
    }
}

export default withTranslation('translations')(EditorTab)
